import { IntlShape } from "react-intl";
import * as v from "valibot";

export const APPROVAL_FILTER = [
  "AWAITING_ANY",
  "AWAITING_MINE",
  "HAS_ANY",
  "HAS_MINE",
] as const;

export const schemaFactory = (intl: IntlShape) =>
  v.object({
    approvalFilter: v.optional(
      v.pipe(
        v.string(),
        v.trim(),
        v.transform((s) => s.toUpperCase()),
        v.transform((s) => (s ? s : undefined)),
        v.optional(
          v.picklist(
            APPROVAL_FILTER,
            intl.formatMessage(
              {
                defaultMessage: "Expected one of {values}",
              },
              {
                values: intl.formatList(APPROVAL_FILTER, {
                  style: "short",
                  type: "disjunction",
                }),
              },
            ),
          ),
        ),
      ),
    ),
    stage: v.optional(
      v.pipe(
        v.string(),
        v.transform((s) => parseInt(s.trim(), 10)),
      ),
    ),
  });

export type Schema = ReturnType<typeof schemaFactory>;
